import { useMemo } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { isNilOrEmpty } from 'ramda-extension';

import { getMessage } from '@gef-ui/localization/messages';

export const TableHasNoResults = ({
	colSpan = 100,
	beforeSearchText = getMessage('common:tableBeforeSearch'),
	noResultsText = getMessage('error:noResults'),
	fetchState,
}) => {
	const finalMessage = useMemo(() => {
		if (!isNilOrEmpty(fetchState)) {
			return fetchState?.loaded ? noResultsText : beforeSearchText;
		}
		return noResultsText;
	}, [fetchState, noResultsText, beforeSearchText]);

	return (
		<TableRow>
			<TableCell colSpan={colSpan}>{finalMessage}</TableCell>
		</TableRow>
	);
};

TableHasNoResults.propTypes = {
	beforeSearchText: PropTypes.string,
	colSpan: PropTypes.number,
	fetchState: PropTypes.object,
	noResultsText: PropTypes.string,
};

export default TableHasNoResults;
